const validationRule: Object = { required: true };
const validationNumberRule: Object = { required: true, number: true };
export const drilingColumns = [
  {
    field: 'id',
    headerText: 'ID',
    width: '100',
    textAlign: 'Left',
    isPrimary: true,
    visible: false,
  },
  {
    field: 'pitt',
    validationRules: validationRule,
    headerText: 'Pit',
    allowEditing:true
  },
  {
    field: 'shot_id',
    validationRules: validationNumberRule,
    headerText: 'Shot ID',
    allowEditing:true,
    editType:'numericedit'
  },
  {
    field: 'rig_no',
    validationRules: validationRule,
    headerText: 'Rig No',
    allowEditing:true
  },
  {
    field: 'description',
    validationRules: validationRule,
    headerText: 'Work Description',
    allowEditing:true
  },
  {
    field: 'drill_m',
    validationRules: validationRule,
    headerText: 'Drill M',
    allowEditing:true
  },
  {
    field: 'hours',
    validationRules: validationRule,
    headerText: 'Hours',
    allowEditing:true
  },
];
